/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomestripunlogged2Inputs */

const en_outcomestripunlogged2 = /** @type {(inputs: Outcomestripunlogged2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letter sent? Tell us how it went →`)
};

const pt_outcomestripunlogged2 = /** @type {(inputs: Outcomestripunlogged2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já enviou a carta? Diga-nos como correu →`)
};

/**
* | output |
* | --- |
* | "Letter sent? Tell us how it went →" |
*
* @param {Outcomestripunlogged2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomestripunlogged2 = /** @type {((inputs?: Outcomestripunlogged2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomestripunlogged2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomestripunlogged2(inputs)
	return pt_outcomestripunlogged2(inputs)
});
export { outcomestripunlogged2 as "outcomeStripUnlogged" }